export default __webpack_public_path__ + "static/media/100009.958d66ab.jpg";